import React from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";

const CustomerPieChart = ({
  PieChartActiveCustomerData,
  PieChartInactiveCustomerData,
}) => {
  const closedCustomers = PieChartInactiveCustomerData
    ? PieChartInactiveCustomerData
    : 0;
  const newCustomers = PieChartActiveCustomerData
    ? PieChartActiveCustomerData
    : 0;
  const series = [newCustomers, closedCustomers];
  const operatorConfiguration = useSelector(
    (state) =>
      state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
  );

  const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;
  const labels = isEIPEnabled
    ? ["Active Devices", "Closed Devices"]
    : ["Active Customers", "Closed Customers"];
  const options = {
    chart: {
      type: "pie",
    },
    labels,
    colors: ["#2E5B88", "#9FCAE6"],
    plotOptions: {
      pie: {
        startAngle: 0,
        endAngle: 360,
        expandOnClick: true,
        offsetX: 0,
        offsetY: 0,
        customScale: 1,
        dataLabels: {
          offset: 0,
          minAngleToShowLabel: 10,
        },
      },
    },
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: false,
    },
  };

  return (
    <div className="App">
      <Chart options={options} series={series} type="pie" height={220} />
    </div>
  );
};

export default CustomerPieChart;
